'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelElementStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  hasTooltip: _propTypes2.default.bool
};
var defaultProps = {
  hasTooltip: _propTypes2.default.bool
};

var spacing = function spacing(_ref) {
  var themeFromProvider = _ref.theme,
      hasTooltip = _ref.hasTooltip;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var labelTooltipSpacing = theme.reactackle.components.checkbox.label.labelTooltipSpacing;
  return hasTooltip ? '\n      & > *:last-child {\n        margin-left: ' + (0, _reactackleCore.getValueString)(labelTooltipSpacing) + ';\n      }\n    ' : '';
};

var LabelElementStyled = exports.LabelElementStyled = _styledComponents2.default.span.withConfig({
  displayName: 'LabelElementStyled'
})(['display:flex;', ';'], spacing);

LabelElementStyled.displayName = 'LabelElementStyled';
LabelElementStyled.propTypes = propTypes;
LabelElementStyled.defaultProps = defaultProps;